import { Box, Button, Step, StepLabel, Stepper } from '@mui/material'
import Header from 'components/Header'
import { BasePathProvider } from 'components/Providers'
import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FaSave } from 'react-icons/fa'
import SchedulingCourseSessionsFormSessionDetails from './SessionDetails'
import SchedulingCourseSessionsFormAssignTeacher from './AssignTeacher'
import SchedulingCourseSessionsFormSetSchedule from './SetSchedule'
import SchedulingCourseSessionsFormEnrollStudent from './EnrollStudent'
import { useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router-dom'

const steps = ['Session Details', 'Assign Teacher(s)', 'Set Schedule', 'Enroll Students']

export default function SchedulingCourseSessionsForm({ control, setValue, getValues, onSubmitSessionDetails, handleSubmit, onErrors }) {
  const { t } = useTranslation()
  const { courseSessionId } = useParams()

  const theme = useSelector(state => state.session.appearance)
  const { state: locationState } = useLocation()

  const basePath = `/scheduling/course-sessions/`

  const [activeStep, setActiveStep] = useState(locationState?.initialStep ?? 0)
  const scheduleSaveRef = useRef(null)

  const handleNext = () => setActiveStep(prev => prev + 1)
  const handleBack = () => setActiveStep(prev => prev - 1)

  const handleSessionDetailsSubmit = async () => {
    const success = await onSubmitSessionDetails()
    if (success) handleNext()
  }

  return (
    <BasePathProvider value={`${basePath}`}>
      <Box
        data-component="SchedulingCourseSessionsForm"
        component="form"
        onSubmit={handleSubmit(handleSessionDetailsSubmit, onErrors)}
        noValidate
        sx={{ overflowY: 'scroll', border: 'none' }}
      >
        <Header
          title={courseSessionId ? getValues()?.courseSession?.name : t('Course Sessions')}
          small
          close
          borderBottom
        />
        <Box sx={{ width: '100%', p: 3, pl: 2 }}>
          <Stepper activeStep={activeStep} sx={{ mb: 2 }}>
            {steps.map((label, index) => {
              const stepProps = {}
              const labelProps = {}
              return (
                <Step key={label} {...stepProps} completed={false}>
                  <StepLabel
                    disabled={true}
                    onClick={courseSessionId === 'new' && index > 0 ? null : () => setActiveStep(index)}
                    sx={{ '.Mui-active circle': { color: 'primary' } }}
                    {...labelProps}
                  >
                    <Box sx={{ cursor: 'pointer' }}>{t(label)}</Box>
                  </StepLabel>
                </Step>
              )
            })}
          </Stepper>
          {activeStep === steps.length ? (
            <>Bla 1</>
          ) : (
            <>
              {activeStep === 0 && (
                <SchedulingCourseSessionsFormSessionDetails
                  control={control}
                  setValue={setValue}
                  getValues={getValues}
                  onSubmitSessionDetails={onSubmitSessionDetails}
                />
              )}
              {/* {activeStep > 0 && (
                <Alert severity="info" variant="outlined" sx={{ mb: 2 }}>
                  {t('Make your changes below, then click')} <strong>{t('Next')}</strong> {t('to continue.')}
                </Alert>
              )} */}
              {activeStep === 1 && <SchedulingCourseSessionsFormAssignTeacher control={control} />}
              {activeStep === 2 && <SchedulingCourseSessionsFormSetSchedule control={control} onNext={handleNext} registerSave={fn => { scheduleSaveRef.current = fn }} />}
              {activeStep === 3 && <SchedulingCourseSessionsFormEnrollStudent control={control} />}
              <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                {activeStep > 0 && (
                  <Button
                    size="small"
                    color="inherit"
                    onClick={handleBack}
                    sx={{ mr: 1, color: theme === 'dark' ? 'rgba(255, 255, 255, 0.38)' : 'rgba(0, 0, 0, 0.38)' }}
                  >
                    {t('Back')}
                  </Button>
                )}
                <Box sx={{ flex: '1 1 auto' }} />
                {activeStep === 0 && (
                  <Button type="submit" size="small" color="primary" variant="contained" startIcon={<FaSave />}>
                    {t('Save & Continue')}
                  </Button>
                )}
                {activeStep === 2 && (
                  <Button size="small" color="primary" variant="contained" startIcon={<FaSave />} onClick={() => scheduleSaveRef.current?.()}>
                    {t('Save & Continue')}
                  </Button>
                )}
                {activeStep === 1 && (
                  <Button size="small" color="primary" variant="contained" onClick={handleNext}>
                    {t('Next')}
                  </Button>
                )}
              </Box>
            </>
          )}
        </Box>
      </Box>
    </BasePathProvider>
  )
}
